const t = "{{currentTime}}/{{duration}}", A = "검색 결과 {{current}}/{{total}}", o = "찾은 결과가 없습니다", n = "{{count}}개 결과를 찾음", E = "{{count}}개 결과를 찾음", c = '$t(HOURS, { "count": {{hours}} }) $t(MINUTES, { "count": {{minutes}} }) $t(SECONDS, { "count": {{seconds}} })부터 재생합니다.', T = '$t(MINUTES, { "count": {{minutes}} }) $t(SECONDS, { "count": {{seconds}} })부터 재생합니다.', _ = '$t(SECONDS, { "count": {{seconds}} })부터 재생합니다.', s = "변경 사항을 대화 기록에 저장하는데 오류입니다.", S = "{{time}}에 대화 기록 라인입니다. 콘텐츠: {{text}}.", N = '대화 기록 라인 컨테이너입니다. 이 컨테이너 안에 $t(TRANSCRIPT_LINES, { "count": {{count}} })개입니다. 이 컨테이너 안에서 탐색하려면 아래 화살표 키를 사용하세요.', R = "변경 사항 저장 중...", O = "변경 사항을 대화 기록에 저장했습니다.", I = "캡션 업데이트 버튼을 이제 사용할 수 있습니다.", C = "작업", P = "{{time}}에 메모 추가", U = "{{time}}에 문제 추가", L = "메모", D = "자동", e = "자동({{quality}})", M = "뒤로", u = "캡션", G = "캡션 언어", Y = "캡션 관리", H = "{{language}} 삭제", r = "글꼴 크기", V = "캡션 언어: {{language}}", B = "{{language}}(자동)", i = "검색 지우기", a = "닫기", K = "의견/댓글", m = "계속", F = "재생 속도 줄이기", d = "음량 {{percent}}% 줄이기", l = "아래 화살표", W = "대화 기록 편집기 닫기", $ = "캡션 업데이트", g = "오류입니다.", h = "저장 중...", Q = "저장되었습니다.", J = "대화 기록 편집", p = "텍스트는 비어있을 수 없습니다.", x = "전체 화면", Z = "{{count}}시간", X = "{{count}}시간", f = "재생 속도 높이기", k = "음량 {{percent}}% 높이기", q = "색 반향", v = "특정 백분율로 이동 (1~10%, 2~20% 등)", y = "시작으로 이동", b = "{{title}}에 대한 작업", j = "키보드 바로 가기 키", w = "언어", z = "왼쪽 화살표", tt = "메인 메뉴", At = "{{count}}분", ot = "{{count}}분", nt = "음소거", Et = "음소거됨", ct = "다음 캡션 언어", Tt = "다음 검색 결과", _t = "비활성", st = "맨 위에", St = "{{time}}에 메모 열기", Nt = "{{time}}에 완료한 퀴즈 열기", Rt = "{{time}}에 퀴즈 열기", Ot = "일시 중지", It = "재생", Ct = "재생 속도", Pt = "재생 속도: {{speed}}x", Ut = "이전 캡션 언어", Lt = "이전 검색 결과", Dt = "품질", et = "품질 메뉴", Mt = "재생", ut = "재생 속도 초기화", Gt = "오른쪽 화살표", Yt = "대화 기록에서 검색", Ht = "{{count}}초", rt = "{{count}}초", Vt = "뒤로 검색 {{seconds}}초", Bt = "앞으로 검색 {{seconds}}초", it = "설정", at = "바로 가기", Kt = "미디어 세부 정보 및 도구", mt = "스페이스", Ft = "재생 속도 메뉴", dt = "자동 스크롤 시작", lt = "캡션 토글", Wt = "음소거 토글", $t = "재생/일시 중지 토글", gt = "은(는) {{count}}개 대화 기록 라인", ht = "은(는) {{count}}개 대화 기록 라인", Qt = "대화 기록 로드...", Jt = "대화 기록을 로드할 수 없습니다.", pt = "대화 기록 옵션", xt = "다시 시도", Zt = "대화 기록 사용할 수 없음", Xt = "위로 화살표", ft = "동영상 설정", kt = "음량", qt = "음량: {{volume}}%", vt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: o,
  A11Y_SEARCH_RESULTS_FOUND: n,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: H,
  CAPTION_FONT_SIZE: r,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: i,
  CLOSE: a,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: W,
  EDIT_CONFIRM: $,
  EDIT_ERROR: g,
  EDIT_SAVING: h,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: X,
  INCREASE_PLAYBACK_SPEED: f,
  INCREASE_VOLUME: k,
  INVERT_COLORS: q,
  JUMP_TO_PERCENTAGE: v,
  JUMP_TO_START: y,
  KEBAB_MENU: b,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: ot,
  MUTE: nt,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: Ht,
  SECONDS_other: rt,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: it,
  SHORTCUT: at,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: Wt,
  TOGGLE_PLAY_PAUSE: $t,
  TRANSCRIPT_LINES: gt,
  TRANSCRIPT_LINES_other: ht,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: Xt,
  VIDEO_SETTINGS: ft,
  VOLUME: kt,
  VOLUME_VALUE: qt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  o as A11Y_SEARCH_NO_RESULTS,
  n as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  H as CAPTION_DELETE,
  r as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  i as CLEAR_SEARCH,
  a as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  W as EDIT_CLOSE,
  $ as EDIT_CONFIRM,
  g as EDIT_ERROR,
  h as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  X as HOURS_other,
  f as INCREASE_PLAYBACK_SPEED,
  k as INCREASE_VOLUME,
  q as INVERT_COLORS,
  v as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  b as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  ot as MINUTES_other,
  nt as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ht as SECONDS,
  rt as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  it as SETTINGS,
  at as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  Wt as TOGGLE_MUTED,
  $t as TOGGLE_PLAY_PAUSE,
  gt as TRANSCRIPT_LINES,
  ht as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  Xt as UP_ARROW,
  ft as VIDEO_SETTINGS,
  kt as VOLUME,
  qt as VOLUME_VALUE,
  vt as default
};
